import { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { SupabaseUserContext } from "../contexts/supabaseUser.context";
 
const PrivateRoute = () => {
 
 // Fetching the user from the user context.
 const { user, authReady } = useContext(SupabaseUserContext);
 const location = useLocation();
 const returnTo = `${location.pathname}${location.search || ""}${location.hash || ""}`;
 const redirectLoginUrl = `/login?redirectTo=${encodeURIComponent(returnTo)}`;
 
 if (!authReady) {
   return (
     <Box sx={{ minHeight: "100vh", display: "grid", placeItems: "center" }}>
       <CircularProgress />
     </Box>
   );
 }

 // If the user is not logged in we are redirecting them
 // to the login page. Otherwise we are letting them to
 // continue to the page as per the URL using <Outlet />.
 return !user ? <Navigate to={redirectLoginUrl} /> : <Outlet /> ;
}
 
export default PrivateRoute;